<template>
	<div>
		<div class="mortgage-calcnew__card"
			:data-code="dfoId"
			v-show="targetSlide === 'product_far_east' && !activeCodes.includes(exceptionOption)"
			@click="getDfoDeduction"
			ref="dfoDeduction">
				<div class="mortgage-calcnew__card-wrapper">
					<div class="mortgage-calcnew__checkbox">
							<div class="dr-checkbox">
								<div class="checkbox">
									<input
									v-model="dfoModel"
									@click="getDfoDeduction"
									data-code="dfo_deduction"
									type="checkbox"
									class="checkbox__input"
									:id="dfoId">
									<label :for="dfoId" class="checkbox__label" data-code="dfo_deduction"></label>
								</div>
							</div>
					</div>
					<div class="mortgage-calcnew__card-title">{{title}}</div>
				</div>
				<div class="mortgage-calcnew__card-description">{{text}}</div>
		</div>
	</div>	
</template>

<script>
export default {
	name: "MortgageCalculatorDfoption",
	props: {
		targetSlide: {
			type: String,
			default: ''
		},
		activeCodes: {
			type: Array
		},
		dfoId: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		},
		realty: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			dfoModel: false,
			optionCode: '',
			exceptionOption: ''
		}
	},
	methods: {
		getDfoDeduction() {
			this.dfoModel = !this.dfoModel;
			this.$emit('getDfoDeduction', {model: this.dfoModel, code: this.optionCode});
		}
	},
	watch: {
		targetSlide(value) {
			if (value === 'product_far_east' && !this.dfoModel && this.$props.dfoId === 'dfo_deduction') {
				this.dfoModel = true;
				this.$emit('getDfoDeduction', {model: this.dfoModel, code: this.optionCode});
			}
		},
		realty() {
			this.dfoModel = false;
			if (this.$props.targetSlide === 'product_far_east' && !this.dfoModel && this.$props.dfoId === 'dfo_deduction') {
				this.dfoModel = true;
				this.$emit('getDfoDeduction', {model: this.dfoModel, code: this.optionCode});
			}
		}
	},
	mounted() {
		this.optionCode = this.$props.dfoId === 'dfo_deduction' ? 'pfr_far_east' : 'salary_client_far_east'; 
		this.exceptionOption = this.$props.dfoId === 'dfo_deduction' ? 'salary_client_far_east' : 'pfr_far_east'; 
	}
}
</script>
